import { Link } from 'react-router-dom';
import { categories } from '@/mocks/games';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-gamepad-line text-2xl text-primary-400"></i>
              </div>
              <span className="text-lg font-heading font-bold">
                火影同人游戏合集
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              汇聚最热门的火影同人游戏，涵盖角色扮演、格斗、策略等多种玩法。让每一位火影粉丝都能找到属于自己的忍者冒险。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4 text-background-50">游戏分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 no-underline"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4 text-background-50">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 no-underline"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/role-playing"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 no-underline"
                >
                  全部游戏
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 no-underline"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base mb-4 text-background-50">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </div>
                <span>contact@naruto-fangame.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-chat-smile-2-line text-sm"></i>
                </div>
                <span>加入我们的社群</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-message-3-line text-sm"></i>
                </div>
                <span>微信公众号：火影同人游戏</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-700/50">
        <div className="w-full px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {currentYear} 火影同人游戏合集. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-sm text-background-500 hover:text-primary-400 transition-colors duration-200 no-underline"
              rel="nofollow"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-sm text-background-500 hover:text-primary-400 transition-colors duration-200 no-underline"
              rel="nofollow"
            >
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}